const SIGNED_TIP_TYPES = {
  BUILDING_A_THINKING_CLASSROOM: 'ST1',
  EQUITY_AND_ACCESSIBILITY: 'ST2',
  FORMATIVE_ASSESSMENT: 'ST3',
  MP1: 'ST4',
  MP2: 'ST5',
  MP3: 'ST6',
  MP4: 'ST7',
  MP5: 'ST8',
  MP6: 'ST9',
  MP7: 'ST10',
  MP8: 'ST11',
  MULTILINGUAL_LEARNERS: 'ST12',
  ENVIRONMENTAL_PRINCIPLES_AND_CONCEPTS: 'ST13',
};

const isMathPracticeSignedTip = (tipType: string): boolean =>
  ['ST4', 'ST5', 'ST6', 'ST7', 'ST8', 'ST9', 'ST10', 'ST11'].includes(tipType);

const isEnvironmentalPrinciplesAndConceptsSignedTip = (
  tipType: string
): boolean =>
  tipType === SIGNED_TIP_TYPES.ENVIRONMENTAL_PRINCIPLES_AND_CONCEPTS;

const isEquityAndAccessibilitySignedTip = (tipType: string): boolean =>
  tipType === SIGNED_TIP_TYPES.EQUITY_AND_ACCESSIBILITY;

export {
  isEnvironmentalPrinciplesAndConceptsSignedTip,
  isEquityAndAccessibilitySignedTip,
  isMathPracticeSignedTip,
};
